
export default class SpendConstants
{
  /**
   *
   * @type {[]}
   */
  static data = [];
}